import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
  TOAST_HIDE_TIME
} from 'Constants/commonConstants';
import Banner from 'Components/Banner';
import Toast from 'Components/Toast';
 // Tailwind CSS with proper normalization
import IdleTimer from 'react-idle-timer';
import './styles/tailwind.css';

import 'react-dates/initialize';

import 'Styles/app.scss';
import './styles/tailwind.css';
import 'react-dates/lib/css/_datepicker.css';
import { 
  GET_PACKING_TYPES, 
  GET_VEHICLE_TYPES, 
  GET_VEHICLE_BODY_TYPES,
  GET_PAYMENT_CYCLES,
  GET_BUSINESS_VOLUMES,
  GET_SLABS,
  GET_PRICING_BASIS,
  GET_PRODUCT_CATEGORIES,
  HIDE_TOAST,
  GET_FUEL_TYPES,
  SSO_DELETE_TOKEN,
  GET_BROADCAST_MSG,
  GET_SSO_CONFIG,
  GET_VENDOR_BIDDING_STATUS,
  GET_SEEKER_COMPANY_LIST,
  GET_DEV_TOOLS_CONFIG
} from 'Constants/actionConstants';
import { deleteToken, getCompanyType, getUser, getToken, setCookie, getCookie, storeLogoutDuration, getLogoutTimeDuration } from 'Utils/storage';
import { GOOGLE_API_KEY, WEB_NOTIFICATION_URL, getDataForNotifWithToken } from 'Utils/api';
import { SEEKER_VALUE } from 'Constants/commonConstants';
import disableDevtool from "disable-devtool";
import { getItemFromLocal } from 'Utils/localStorage';
// import webpush from 'web-push';
 

class App extends Component {

  onIdle = () => {
    deleteToken();
    if(location.pathname !== '/') {
      this.idleTimer.reset();
      location.href = '/';
    }
  }

  onSSOIdle = () => {
    // location.replace(`${SSO_BASE_URL}${SSO_URL}/?slo`);
    // setTimeout(() => {deleteToken(), localStorage.clear()}, 2000);
    deleteToken();
    this.idleTimer.reset();
  }

  endSession = () => {
    deleteToken();
  }

  render() {
    const { dispatch } = this.props;
    const { toast, broadcastMsgs } = this.props;
    const user = getUser();
    const isSSOUser = localStorage.getItem('isSSOUser');
    const isSessionActive = localStorage.getItem('sso-session');
    const lastLogoutTimeDuration = getLogoutTimeDuration();
    let currrentTime = new Date();
    const logoutTime = user.logoutTimeoutDuration;
    const diffMins = (Math.abs((currrentTime.getTime() - (new Date(lastLogoutTimeDuration).getTime())) / 1000)) > logoutTime;
    console.log(diffMins)
    this.timer = null;
    if(toast.type && toast.message) {
      if(this.timer) {
        clearTimeout(this.timer);
      }
      let hideTime = TOAST_HIDE_TIME*1000;
      if (toast.duration) {
        hideTime = toast.duration*1000;
      }
      this.timer = setTimeout(()=> {
        dispatch({
          type: HIDE_TOAST
        });
      }, hideTime);
    }
    if(isSSOUser && isSessionActive === 'false' && diffMins){
      this.endSession();
    }
    if(isSSOUser === 'true'){
      return (
        <div className="ct-app pr"> 
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            onIdle={this.onSSOIdle}
            timeout={1000 * (user.idleTimeoutDuration || (60*5))}
            // timeout={1000 * 60 * 5}
          >
          {broadcastMsgs && broadcastMsgs.length > 0 && <Banner data={broadcastMsgs} close={this.closeBanner} islogin={location.pathname==='/'} />}
          <Toast type={toast.type} message={toast.message}/>
          {this.props.children}
          </IdleTimer>
        </div>
      );
    } else {
      return (
        <div className="ct-app pr"> 
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            onIdle={this.onIdle}
            timeout={1000 * 60 * 60}
          >
          {broadcastMsgs && broadcastMsgs.length > 0 && <Banner data={broadcastMsgs} close={this.closeBanner} islogin={location.pathname==='/'} />}
          <Toast type={toast.type} message={toast.message}/>
          {this.props.children}
          </IdleTimer>
        </div>
      );
    }
  }
  componentWillMount() {
    // if (window.parent.frames.length > 0) {
    //   var antiClickjack = document.getElementById("antiClickjack");
    //   antiClickjack.innerHTML = '';
    // }
    if(this.notifTimer) {
      clearInterval(this.notifTimer);
    }
  }

  disableDevTools = () => {
    const devConfig = getItemFromLocal('devTools');
    const moduleData = devConfig && (devConfig.access || []).find(el => (el.module_id == 1));
    if (moduleData && !moduleData.dev_tools_enable) {
        disableDevtool();
    }
  }
  
  componentDidMount() {
    const isSSOUser = localStorage.getItem('isSSOUser');
    const isSessionActive = localStorage.getItem('sso-session');
    this.attachGoogleKeyScript();
    const user = getUser();
    let params = {
      module: 1,
      force_auth: user.forceAuthentication
    }
    // this.getNotification();
    const { dispatch } = this.props;
    const token = getToken();
    // dispatch({
    //   type: GET_PACKING_TYPES,
    // })
    // dispatch({
    //   type: GET_VEHICLE_TYPES,
    // })
    // dispatch({
    //   type: GET_VEHICLE_BODY_TYPES,
    // })
    // dispatch({
    //   type: GET_PAYMENT_CYCLES,
    // })
    // dispatch({
    //   type: GET_BUSINESS_VOLUMES,
    // })
    dispatch({ 
      type: GET_BROADCAST_MSG, 
      params: {module_id: 1}
    });

    dispatch({
      type: GET_DEV_TOOLS_CONFIG,
      onSuccess: this.disableDevTools
    });
    // dispatch({
    //   type: GET_SLABS,
    // });
    dispatch({
      type: GET_SSO_CONFIG,
      params: {}
    });
    // dispatch({
    //   type: GET_PRICING_BASIS,
    // })
    // dispatch({
    //   type: GET_PRODUCT_CATEGORIES,
    // })
    if(token) {
      dispatch({
        type : GET_FUEL_TYPES,
        params: {
          companyId: getUser().companyId
        }
      });
      dispatch({
        type: GET_VENDOR_BIDDING_STATUS
      });
      if([2,9,10,21,22,24,12, 13, 14, 27].includes(user.companyType)) {
        dispatch({
          type: GET_SEEKER_COMPANY_LIST
        });
      }
    }
    if(isSSOUser === 'true' && isSessionActive === 'true'){
        window.addEventListener('beforeunload', function (e) {
        e.preventDefault();
        const isTEGComponent = localStorage.getItem('teg-component');
        const ssoConfigData = (JSON.parse(localStorage.getItem('ssoConfigData') || '') )|| {};
        if(isTEGComponent !== 'true' && ssoConfigData.delete_session_on_tab_close){
          localStorage.setItem('sso-session', false);
          dispatch({
            type: SSO_DELETE_TOKEN,
            params
          })
          storeLogoutDuration(new Date().valueOf());
        }  
        localStorage.setItem('teg-component', ssoConfigData.delete_session_on_tab_close || false);
      });
    }
    // disableDevtool();
  }

  attachGoogleKeyScript = () => {
    const script = document.createElement("script");
    script.src = 'https://maps.googleapis.com/maps/api/js?key='+ GOOGLE_API_KEY +'&v=3.exp&libraries=places';
    script.async = true;
    script.type = 'text/javascript';

    document.head.appendChild(script);
  }
}

// document.addEventListener('visibilitychange', function() {
//   if(document.visibilityState === 'hidden' && getCompanyType() !== SEEKER_VALUE && getToken()) {
//       let count = 0;
//       setTimeout(() => {
//         console.log('count', count + 1);
//         getDataForNotifWithToken(WEB_NOTIFICATION_URL, {
//         transporterId: getUser().id
//       })}, 30000);
//   }
// });

const mapStateToProps = ({common}) => {
  return {
    toast: common.toast,
    broadcastMsgs: common.broadcastMsgs
  }
};

export default connect(mapStateToProps)(App);
